import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import { computed } from 'vue'

import { useLocalizedRouters } from '@/composables/localized-routers'
import { useI18nAddon } from '@/i18n/i18n'
import { AvailableLocale } from '@/i18n/types'
import { updateLocaleCookie } from '@/utils/cookie-parser'

import LocaleSwitcher from './LocaleSwitcher.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'LocaleSwitchersList',
  props: {
    languageLinks: {}
  },
  setup(__props: any) {



const i18nAddon = useI18nAddon()
const { getLocalizedUrls } = useLocalizedRouters()

const locales = computed(() => {
    const supportedLocales = i18nAddon.getSupportedLocales()
    const urls = __props.languageLinks || getLocalizedUrls()

    return supportedLocales.map((locale) => {
        return {
            href: urls[locale],
            locale,
            isSelected: locale === i18nAddon.currentLocale.value,
        }
    })
})

function updateLocale(locale: AvailableLocale) {
    if (locale !== i18nAddon.currentLocale.value) {
        i18nAddon.setPreferredLocale(locale)
        updateLocaleCookie(locale)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.locale_switchers)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locales.value, ({ locale, href, isSelected }) => {
      return (_openBlock(), _createBlock(LocaleSwitcher, {
        key: locale,
        locale: locale,
        href: href,
        isSelected: isSelected,
        onClick: updateLocale
      }, null, 8, ["locale", "href", "isSelected"]))
    }), 128))
  ], 2))
}
}

})